import initialState from '../../initialState';
import * as actionTypes from '../../../actions/actionTypes';

export default function hubUpcomingSessionsPageReducer(state = initialState.ui.apiState.hubUpcomingSessionsPage, action) {
  switch (action.type) {
    case actionTypes.HUB_SP_FETCH_UPCOMING_SESSIONS_START:
      return {
        ...state,
        fetchError: false,
        isLoading: true,
      };
    case actionTypes.HUB_SP_FETCH_UPCOMING_SESSIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasFetched: true,
      };
    case actionTypes.HUB_SP_FETCH_UPCOMING_SESSIONS_FAILED:
      return {
        ...state,
        fetchError: true,
        isLoading: false,
      };
    case actionTypes.HUB_SP_FETCH_UPCOMING_SESSIONS_FAILURE_DEFINITIVE:
      return {
        ...state,
        fetchError: true,
        isLoading: false,
        retryEnabled: false,
      };
    default:
      return state;
  }
}
